/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGroupAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4zm18 0H4v16h.07c.159-1.111.591-2.203 1.362-3.092C6.453 15.728 7.99 15 10 15s3.546.729 4.568 1.908c.77.889 1.203 1.98 1.362 3.092h2.638a3.45 3.45 0 0 0-.78-1.058 3.445 3.445 0 0 0-1.377-.756 7.013 7.013 0 0 0-1.511-2.185L15 16c1.733 0 3.123.542 4.135 1.464.337.307.624.649.865 1.015V4zm-6.099 16c-.139-.678-.421-1.295-.844-1.783C12.453 17.521 11.49 17 10 17s-2.453.521-3.057 1.217c-.423.488-.706 1.105-.844 1.783h7.802zm.45-7.535a5.025 5.025 0 0 1-1.322 1.514 3.5 3.5 0 1 0 1.601-5.87 4.986 4.986 0 0 1 .37 1.977 1.5 1.5 0 1 1-.648 2.38zM8 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGroupAvatar as GroupAvatar };
